import { isArray, isNumber, toNumber } from '@develop/ia-utils'
import type { MimeType } from '~/models/prescription'

// TODO: replace all of these with exports from ia-utils
export const isValidUrl = (url: string) => {
  try {
    // eslint-disable-next-line no-new
    new URL(url)
    return true
  } catch (e) {
    return false
  }
}

export const isIadeEnvironment = (url: string | URL) => {
  url = new URL(url)
  return /^(.*\.)?(ihreapotheken\.de|ia\.de)$/i.test(url.host)
}

export const mimeTypeToExtension = (mimeType: MimeType) => {
  // TODO: Move this to utils library and handle all mime types instead of only common ones
  const mimeTypes = {
    'application/pdf': '.pdf',
    'application/vnd.rar': '.rar',
    'application/zip': '.zip',
    'application/gzip': '.gz',
    'application/msword': '.doc',
    'application/json': '.json',
    'image/png': '.png',
    'image/jpeg': '.jpeg',
    'image/svg+xml': '.svg',
    'image/avif': '.avif',
    'image/bmp': '.bmp',
    'image/vnd.microsoft.icon': '.ico',
    'audio/mpeg': '.mp3',
    'audio/webm': '.weba',
    'audio/wav': '.wav',
    'video/mp4': '.mp4',
    'video/mpeg': '.mpeg',
    'video/webm': '.webm',
    'text/csv': '.csv',
    'text/plain': '.txt',
  }

  return mimeTypes[mimeType]
}

export const convertUmlaut = (umlaut: string) => {
  switch (umlaut) {
    case 'Ü':
      return 'Ue'
    case 'ü':
      return 'ue'
    case 'Ä':
      return 'Ae'
    case 'ä':
      return 'ae'
    case 'Ö':
      return 'Oe'
    case 'ö':
      return 'Oe'
    case 'ß':
      return 'ss'
    default:
      return ''
  }
}

export const replaceUmlaut = (value: string) => {
  return value.replace(/Ü|ü|Ä|ä|Ö|ö|ß/g, convertUmlaut)
}

export const ensureArray = <T>(value: T | T[]): T[] => {
  return isArray(value) ? value : [value]
}

export const isNumericString = (value: string | number): boolean => {
  return isNumber(toNumber(value))
}

export function extractIdFromSlug(slug: string, opts?: { parseNumber?: boolean }): string | number | undefined {
  const matches = slug.match(slugWithIdRegex)
  // Id is always at the end of the slug, don't confuse it with other numbers in the slug
  // e.g. 11-a-nutritheke-gmbh-3514 --> 3514 is the id
  const matchedId = matches?.at(-1)

  if (!matchedId) {
    return undefined
  }

  if (opts?.parseNumber) {
    return toNumber(matchedId) as number | undefined
  }

  return matchedId as string
}

export const convertSlugsToNumberIds = (slugs: string[]) => {
  return slugs.map((slug) => {
    return extractIdFromSlug(slug, { parseNumber: true })
  }).filter(isNumber)
}

export const convertArrayToStringArray = <T>(arr: T[]): string[] => {
  return arr.map(String)
}

export const convertArrayToNumberArray = <T>(arr: T[]): number[] => {
  return arr.map(toNumber).filter(isNumber)
}
